import { Injectable } from '@angular/core';
import { EnvConfigurationService } from '../envconf/envconf.service';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../api/api.service';
import { Pagination } from '../../models/pagination';
import { AutomakerDto, AutomakerNoIdDto } from '../../models/automaker/automaker-dto';
import { PaginatedResponse, PaginatorFilters } from '@michelin/theme';
import { map, Observable } from 'rxjs';
import { AutomakerPriceItemDto } from '../../models/automaker/automaker-price-item-dto';

@Injectable({
  providedIn: 'root'
})
export class AutomakerService {
  endpoint = `${EnvConfigurationService.configuration.BACKEND_URL}${EnvConfigurationService.configuration.BACKEND_SUB_PATH}/automakers`;

  constructor(private readonly http: HttpClient, private readonly apiService: ApiService) {}

  getPaginatedResponse(pagination: Pagination<AutomakerDto>): PaginatedResponse<AutomakerDto> {
    return {
      count: pagination.totalElements,
      items: pagination.content
    };
  }

  getPaginatedPriceItemResponse(pagination: Pagination<AutomakerPriceItemDto>): PaginatedResponse<AutomakerPriceItemDto> {
    return {
      count: pagination.totalElements,
      items: pagination.content
    };
  }

  search(paginatorFilters?: PaginatorFilters): Observable<PaginatedResponse<AutomakerDto>> {
    return this.http
      .get<PaginatedResponse<AutomakerDto>>(`${this.endpoint}/search${this.apiService.getQueryParams(paginatorFilters)}`)
      .pipe(map((items: Pagination<AutomakerDto>) => this.getPaginatedResponse(items)));
  }

  findAll(): Observable<AutomakerDto[]> {
    return this.http.get<AutomakerDto[]>(`${this.endpoint}`);
  }

  findById(automakerId: number): Observable<AutomakerDto> {
    return this.http.get<AutomakerDto>(`${this.endpoint}/${automakerId}`);
  }

  create(data: AutomakerNoIdDto): Observable<AutomakerDto> {
    return this.http.post<AutomakerDto>(this.endpoint, data);
  }

  update(automakerId: number, data: AutomakerNoIdDto): Observable<AutomakerDto> {
    return this.http.put<AutomakerDto>(`${this.endpoint}/${automakerId}`, data);
  }

  uploadOrders(automakerId: number, orderFile: File): Observable<Object> {
    const data = new FormData();
    data.append('file', orderFile);
    return this.http.post(`${this.endpoint}/upload/orders/automakers/${automakerId}`, data);
  }

  uploadPriceTable(automakerId: number, orderFile: File): Observable<Object> {
    const data = new FormData();
    data.append('file', orderFile);
    return this.http.post(`${this.endpoint}/upload/price/automakers/${automakerId}`, data);
  }

  exportExcel() {
    return this.http.get(`${this.endpoint}/download`, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  searchPrice(paginatorFilters?: PaginatorFilters): Observable<PaginatedResponse<AutomakerPriceItemDto>> {
    return this.http
      .get<PaginatedResponse<AutomakerPriceItemDto>>(
        `${this.endpoint}/search/automakerPrice${this.apiService.getQueryParams(paginatorFilters)}`
      )
      .pipe(map((items: Pagination<AutomakerPriceItemDto>) => this.getPaginatedPriceItemResponse(items)));
  }

  downloadModelFile(automakerId: number) {
    return this.http.get(`${this.endpoint}/download/priceTable/modelFile/automakers/${automakerId}`, {
      responseType: 'blob',
      observe: 'response'
    });
  }
}
